export function getNow() {
  return Date.now();
}

export function parseDate(input) {
  if (!input) return null;
  const t = (typeof input === 'string' || typeof input === 'number') ? new Date(input) : input;
  const ms = t instanceof Date ? t.getTime() : Number.NaN;
  return Number.isFinite(ms) ? ms : null;
}

/** Decide subscription state for current user on this channel */
export function computeSubState({ overview, isMember }) {
  const sub = overview && overview.subscription ? overview.subscription : null;
  const price = Number(overview?.price || 0);
  const isPaidChannel = String(overview?.type || '').toLowerCase() === 'subscribers' && price > 0;

  const expiresMs = parseDate(sub?.expiresAt);
  const now = getNow();

  const hasSub = !!sub;
  const expired = !!(expiresMs && expiresMs <= now);
  const autoRenewOn = !!(sub && sub.isRecurring);
  const autoRenewOff = !!(sub && !sub.isRecurring);

  return {
    isPaidChannel,
    hasSub,
    expired,
    autoRenewOn,
    autoRenewOff,
    expiresMs,
    isMember: !!isMember,
  };
}

/** human date like �Oct 30, 2025� */
export function formatDate(ms) {
  if (!Number.isFinite(ms)) return '';
  try {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
    }).format(new Date(ms));
  } catch {
    return new Date(ms).toLocaleDateString();
  }
}